export default __webpack_public_path__ + "img/InterDisplay-ExtraLightItalic_57bcc57.woff2";